import React from 'react'
import Grid from '@mui/material/Grid'
import TextField from '@mui/material/TextField'

const AffectedArea = ({ moduleValues, setModuleValues }) => (
  <Grid item xs={12} lg={4}>
    <TextField
      fullWidth
      label="Affected Area"
      value={moduleValues['Affected Area'] ?? ''}
      onChange={(e) =>
        setModuleValues((prev) => ({
          ...prev,
          ['Affected Area']: e.target.value,
        }))
      }
    />
  </Grid>
)

export default AffectedArea
